/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-wrapper-object-types */
import {defaultValues} from '../../data/constants/inscription';
import {IError} from '../../data/types/interface/inscription';
import {
  MAIL_VALIDATION,
  MESSAGE_VALIDATION,
  PASSWORD_VALIDATION,
} from './validation';

const listRequiredField = (
  required: Array<any>,
  notRequired: Array<String>,
) => {
  const aResult = required.filter(elt => !notRequired.includes(elt[0]));
  return aResult;
};

export const Validation = (values: IError) => {
  let errors: IError = {...defaultValues};
  const aNotRequiredField = ['cin'];
  const aRequiredField = listRequiredField(
    Object.entries(values),
    aNotRequiredField,
  );

  /** mail checking */
  if (!MAIL_VALIDATION.test(values.email)) {
    errors.email = MESSAGE_VALIDATION.requiredEmail;
  }

  /** telphone cheking */
  if (!PASSWORD_VALIDATION.test(values.password)) {
    errors.password = MESSAGE_VALIDATION.requiredPassword;
  }

  if (values.password !== values.passwordConfirmation) {
    errors.passwordConfirmation = MESSAGE_VALIDATION.passwordConfirmation;
  }

  if (values.dateNaissance !== '') {
    const _ageMin = 21;
    const _date = new Date(values.dateNaissance);
    const minDate = new Date();
    minDate.setFullYear(new Date().getFullYear() - _ageMin);
    if (_date >= minDate) {
      errors.dateNaissance = `L'âge minimum valide est de ${_ageMin} ans`;
    }
  }

  if (values.cin.length < 2) {
    errors.cin = MESSAGE_VALIDATION.requiredCin;
  }

  /** checking all required values */
  aRequiredField.forEach(element => {
    if (
      element[1] === '' ||
      element[1] === null ||
      element[1] === 'INVALID INPUT' ||
      (Array.isArray(element[1]) && element[1].length === 0)
    ) {
      errors = {...errors, [element[0]]: MESSAGE_VALIDATION.requiredField};
    }
  });

  return errors;
};
